<template>
    <div class="file-wrapper-rejection">
        <div class="file-wrapper-rejection__header">
            <div class="file-wrapper-rejection__header__type">
                <PtIcon class="file-wrapper-rejection__header__type__icon" icon="SolidProfile" />
                <span class="file-wrapper-rejection__header__type__name">{{ $t('fileWrapperMultiView.examiner') }}</span>
            </div>
            <div class="file-wrapper-rejection__header__title">
                {{ title }}
            </div>
        </div>
        <FileWrapperMultiViewPdf
            class="file-wrapper-rejection__main"
            :pdf="pdfLink"
        />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import FileWrapperMultiViewPdf from './FileWrapperMultiViewPdf.vue';
import useFileWrapperMultiView from '../../composables/use-file-wrapper-multi-view';
import _ from 'lodash';
import { getI18nInstance } from '@/locales/i18nInstance';
import { Icon as PtIcon } from 'patsnap-biz';
import '@patsnap-ui/icon/assets/solid/profile.svg';

const i18n = getI18nInstance();

const { currentRoundDetail } = useFileWrapperMultiView();

const rejectionData = computed(() => {
    return _.get(currentRoundDetail.value, 'rejection', {});
});

const title = computed(() => {
    const mrdt = _.get(rejectionData.value, 'mrdt', '');
    const rejection = currentRoundDetail.value?.doc_code === 'CTNF' ? i18n.t('fileWrapperMultiView.nonFinalRejection') : i18n.t('fileWrapperMultiView.finalRejection');
    return `${mrdt} ${rejection}`;
});

const pdfLink = computed(() => {
    return _.get(rejectionData.value, 'pdf', '');
});

</script>

<style lang="scss">
.file-wrapper-rejection {
    height: 100%;
    //width: 100%;
    background: $bg-normal;
    padding: 0 16px 16px 16px;
    display: flex;
    flex-direction: column;

    .file-wrapper-rejection__header {
        height: 40px;
        display: flex;
        align-items: center;
        flex-shrink: 0;

        .file-wrapper-rejection__header__type {
            border-radius: 20px;
            background: $status-yellow-light;
            padding: 0 8px 0 4px;
            display: flex;
            align-items: center;
            font-size: 12px;

            .file-wrapper-rejection__header__type__icon {
                font-size: 20px;
                color: $status-yellow-primary;
            }

            .file-wrapper-rejection__header__type__name {
                color: $status-yellow-primary;
                margin-left: 4px;
            }
        }

        .file-wrapper-rejection__header__title {
            margin-left: 8px;
            font-weight: 600;
        }
    }

    .file-wrapper-rejection__main {
        flex: 1;
    }
}
</style>
